<template>
  <material-card>
    <v-layout slot="header" px-3>
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Kontenery na punkty</div>

        <p>Lista kontenerów</p>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex text-xs-right>
        <check-permission permissions="POINT_CONTAINER.ADD">
          <v-btn large color="error" @click="showAddModal">Dodaj kontener</v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <material-table
      entity-type="POINT_CONTAINER"
      :headers="table.headers"
      :actions="table.actions"
      :items="list"
      :total-count="count"
      @edit="showEditModal($event.id)"
      @delete="remove($event.id)"
      @manageBenefits="manageBenefits($event.id)"
      @containerHistory="showHistory($event.id)"
    />

    <add-container :id="idToEdit" :show="showModal" @close="hideModal" @update="update" @save="add" />

    <manage-container-benefits
      :point-container-id="pointContainerId"
      :global="true"
      :show="showManageModal"
      @close="hideManageModal"
    />
  </material-card>
</template>

<script>
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import AddContainer from '../partners/tabs/modals/AddContainer.modal';
import ManageContainerBenefits from '../partners/tabs/modals/ManageContainerBenefits.modal';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania listy kontenerów.',
  getError: 'Wystąpił błąd podczas pobierania danych kontenera.',
  added: 'Dodano kontener.',
  addError: 'Nie udało się dodać kontenera.',
  updated: 'Zaktualizowano dane kontenera.',
  updateError: 'Nie udało się zaktualizować danych kontenera.',
  deleted: 'Usunięto kontener.',
  deleteError: 'Nie udało się usunąć kontenera.'
};

// @vuese
// Kontenery
// @group Tabs
export default {
  components: { MaterialCard, AddContainer, MaterialTable, ManageContainerBenefits },

  mixins: [listMixin('pointContainers', messages)],
  data() {
    return {
      table: {
        headers: [
          { value: 'id', text: 'ID', sortable: true },
          { value: 'name', text: 'Nazwa', sortable: true }
        ],
        actions: [
          EDIT_ACTION,
          DELETE_ACTION,
          {
            icon: 'mdi-format-list-numbered-rtl',
            event: 'manageBenefits',
            permissionTypes: [],
            tooltipText: 'Przypisania usług'
          },
          { icon: 'mdi-history', event: 'containerHistory', permissionTypes: [], tooltipText: 'Historia' }
        ]
      },
      showManageModal: false,
      pointContainerId: null
    };
  },
  computed: {
    ...mapState({
      list: state => state.pointContainers.list,
      count: state => state.pointContainers.count
    })
  },
  methods: {
    // @vuese
    // Otworzenie modala zarządzania przypisaniami
    manageBenefits(id) {
      this.$store.dispatch('containerBenefit/list', { count: -1, pointContainerId: id }).then(() => {
        this.pointContainerId = id;
        this.showManageModal = true;
      });
    },
    // @vuese
    // Zamknięcie modala zarządzania przypisaniami
    hideManageModal() {
      this.showManageModal = false;
      this.pointContainerId = null;
    },
    // @vuese
    // Zwraca obiekt filtrów z paginacją
    filters(pagination, route) {
      return { ...pagination };
    },
    // @vuese
    // Przejście do historii punktów kontenera
    showHistory(id) {
      this.$router.push({ name: 'containerHistory', params: { pointContainerId: id } });
    }
  }
};
</script>
